import { render, staticRenderFns } from "./admin-global-search.vue?vue&type=template&id=3c5dd919"
import script from "./admin-global-search.vue?vue&type=script&lang=js"
export * from "./admin-global-search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c5dd919')) {
      api.createRecord('3c5dd919', component.options)
    } else {
      api.reload('3c5dd919', component.options)
    }
    module.hot.accept("./admin-global-search.vue?vue&type=template&id=3c5dd919", function () {
      api.rerender('3c5dd919', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin-global-search.vue"
export default component.exports